module.exports = __webpack_public_path__ + "img/log-in-04.ed005200.svg";